/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Server_Busy_TitleInputs */

const en_dialog_server_busy_title = /** @type {(inputs: Dialog_Server_Busy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`System Busy`)
};

const ar_dialog_server_busy_title = /** @type {(inputs: Dialog_Server_Busy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النظام مشغول`)
};

const de_dialog_server_busy_title = /** @type {(inputs: Dialog_Server_Busy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`System beschäftigt`)
};

const es_dialog_server_busy_title = /** @type {(inputs: Dialog_Server_Busy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El sistema está ocupado`)
};

const fr_dialog_server_busy_title = /** @type {(inputs: Dialog_Server_Busy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serveur occupé`)
};

const it_dialog_server_busy_title = /** @type {(inputs: Dialog_Server_Busy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistema occupato`)
};

const ja_dialog_server_busy_title = /** @type {(inputs: Dialog_Server_Busy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`システムがビジー状態です`)
};

const ko_dialog_server_busy_title = /** @type {(inputs: Dialog_Server_Busy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시스템 혼잡`)
};

const pt_br_dialog_server_busy_title = /** @type {(inputs: Dialog_Server_Busy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistema ocupado`)
};

const ru_dialog_server_busy_title = /** @type {(inputs: Dialog_Server_Busy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Система занята`)
};

const th_dialog_server_busy_title = /** @type {(inputs: Dialog_Server_Busy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ระบบไม่ว่าง`)
};

const tr_dialog_server_busy_title = /** @type {(inputs: Dialog_Server_Busy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistem Meşgul`)
};

const zh_cn_dialog_server_busy_title = /** @type {(inputs: Dialog_Server_Busy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`系统繁忙中`)
};

const zh_tw_dialog_server_busy_title = /** @type {(inputs: Dialog_Server_Busy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`系統繁忙中`)
};

/**
* | output |
* | --- |
* | "System Busy" |
*
* @param {Dialog_Server_Busy_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_server_busy_title = /** @type {((inputs?: Dialog_Server_Busy_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Server_Busy_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_server_busy_title(inputs)
	if (locale === "ar") return ar_dialog_server_busy_title(inputs)
	if (locale === "de") return de_dialog_server_busy_title(inputs)
	if (locale === "es") return es_dialog_server_busy_title(inputs)
	if (locale === "fr") return fr_dialog_server_busy_title(inputs)
	if (locale === "it") return it_dialog_server_busy_title(inputs)
	if (locale === "ja") return ja_dialog_server_busy_title(inputs)
	if (locale === "ko") return ko_dialog_server_busy_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_server_busy_title(inputs)
	if (locale === "ru") return ru_dialog_server_busy_title(inputs)
	if (locale === "th") return th_dialog_server_busy_title(inputs)
	if (locale === "tr") return tr_dialog_server_busy_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_server_busy_title(inputs)
	return zh_tw_dialog_server_busy_title(inputs)
});